export default __webpack_public_path__ + "static/media/open-sans.ec3ceaaa.ttf";